<script lang="ts">
  import RoomTypeSection from './RoomTypeSection.svelte'
  import TypesSection from './TypesSection.svelte'
  import CheckboxSection from './CheckboxSection.svelte'
  import filters from '../lib/stores/filters'
  import useFilter from '../hooks/use-filter'
  import Category from './Category.svelte'

  const { resetTypeCategory } = filters
  const { categories } = useFilter()
  const { id, accommodationTypes, roomType, accommodationWith } = categories.type
</script>

<Category {id} on:reset={resetTypeCategory}>
  <TypesSection {...accommodationTypes} />
  <CheckboxSection {...accommodationWith} />
  {#if roomType}
    <RoomTypeSection {...roomType} />
  {/if}
</Category>
